import { defineComponent } from 'vue';
import { DEFAULT_UI_SCALE, getUiScale, nextUiScale, setUiScale, UI_SCALE_EVENT, UI_SCALES } from '@/client/utils/uiScale';
export default defineComponent({
    name: 'UiScaleControl',
    data() {
        return {
            scale: getUiScale(),
            smallest: UI_SCALES[0],
            largest: UI_SCALES[UI_SCALES.length - 1],
            DEFAULT_UI_SCALE,
        };
    },
    mounted() {
        window.addEventListener(UI_SCALE_EVENT, this.sync);
        window.addEventListener('keydown', this.onKey);
    },
    unmounted() {
        window.removeEventListener(UI_SCALE_EVENT, this.sync);
        window.removeEventListener('keydown', this.onKey);
    },
    methods: {
        sync(e) {
            this.scale = e.detail;
        },
        change(scale) {
            setUiScale(scale);
        },
        step(direction) {
            this.change(nextUiScale(this.scale, direction));
        },
        // Alt + plus / minus / 0, like the browser's own zoom keys (which an installed app does not have).
        onKey(e) {
            if (!e.altKey || e.ctrlKey || e.metaKey) {
                return;
            }
            if (e.key === '=' || e.key === '+') {
                this.step(1);
            }
            else if (e.key === '-') {
                this.step(-1);
            }
            else if (e.key === '0') {
                this.change(DEFAULT_UI_SCALE);
            }
            else {
                return;
            }
            e.preventDefault();
        },
    },
});
